module.exports = __webpack_public_path__ + "img/footer_bg.0fa212d3.png";